// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"476":"veranstaltungen","594":"about","596":"gruppen","665":"kontakt"}[chunkId] + "." + {"476":"ad288682","594":"da18b554","596":"fbe5232f","665":"a061fdcf"}[chunkId] + ".js";
};